const playerSelector = '.js-video-popup';

export class VideoPopup {
  static isOnPage() {
    return $(playerSelector).length !== 0;
  }

  constructor() {
    this.load();
    this.init();
  }

  load() {
    /**
     * JW Player support for magnific popup
     */

    const currentJwplayer = {
      player: null,
      playerElement: null,
      playerId: 'mfp-jwplayer-instance',

      setCurrentPlayer(player) {
        this.player = player;
      },

      setCurrentPlayerElement(playerElement) {
        this.playerElement = playerElement;
      },

      getCurrentPlayer() {
        return this.player;
      },

      getCurrentPlayerElement() {
        return this.playerElement;
      },

      reset() {
        this.player = null;
        this.playerElement = null;
      }
    };

    const getCloseModalAriaLabel = () => {
      const videoObj = $('.js-video-popup');
      if (videoObj.length > 0) {
        const ariaLabel = videoObj.data('close-aria-label');

        return ariaLabel || 'Close';
      }

      return 'Close';
    };

    const closeBtnAriaLabel = getCloseModalAriaLabel();

    $.magnificPopup.registerModule('jwplayer', {
      options: {
        markup:
          '<div class="mfp-jw-wrapper">' +
          '<button type="button" aria-label="' + closeBtnAriaLabel + '" class="mfp-close">&times;</button>' +
          '<div id="mfp-jwplayer"></div>' +
          '</div>'
      },

      proto: {
        initJwplayer() {
          // Initialize event handlers
        },

        hideOriginalButton(element) {
          currentJwplayer.setCurrentPlayerElement(element);
          if (element) {
            element.style.display = 'none';
          }
        },

        instantiatePlayer() {
          const element = currentJwplayer.getCurrentPlayerElement();
          if (!element) {
            return;
          }
          const urlProgressive = element.getAttribute('data-video-url-progressive') || element.getAttribute('href');
          const urlHls = element.getAttribute('data-video-url-hls');
          const urlVideoUrl = element.getAttribute('data-video-url');
          const videoName = element.getAttribute('data-video-title') || element.getAttribute('data-video-name') || 'Video';
          const existingContainer = document.getElementById(currentJwplayer.playerId);

          if (existingContainer) {
            existingContainer.remove();
          }

          const playerContainer = document.createElement('div');
          playerContainer.id = currentJwplayer.playerId;

          if (typeof window.setupVideoPlayer === 'function') {
            try {
              document.body.appendChild(playerContainer);
              const player = window.setupVideoPlayer(currentJwplayer.playerId, {
                playlist: [{
                  file: urlProgressive || urlHls || urlVideoUrl,
                  title: videoName
                }],
                autostart: true,
                ga4analytics: false,
                controls: true,
                mute: false
              });
              currentJwplayer.setCurrentPlayer(player);
            } catch (error) {
              // Silent error handling
            }
          }
        },

        appendPlayerToPopup() {
          if (!currentJwplayer.getCurrentPlayer()) {
            return;
          }

          const checkInterval = setInterval(() => {
            const mfpPlayer = document.querySelector('#mfp-jwplayer');
            const playerElement = document.getElementById(currentJwplayer.playerId);

            if (mfpPlayer && playerElement) {
              while (mfpPlayer.firstChild) {
                mfpPlayer.removeChild(mfpPlayer.firstChild);
              }
              const videoTitle = currentJwplayer.getCurrentPlayerElement().getAttribute('data-video-title');

              playerElement.setAttribute('aria-label', videoTitle);
              playerElement.setAttribute('role', 'presentation');
              mfpPlayer.appendChild(playerElement);
              clearInterval(checkInterval);
            }
          }, 50);

          setTimeout(() => {
            clearInterval(checkInterval);
          }, 5000);
        },

        getJwplayer(item, template) {
          const that = this;
          this.updateStatus('ready');
          let isDone = false;
          let clickedElement = null;

          const magnificPopupSetup = (e) => {
            if (!isDone) {
              try {
                if (e.type === 'mfpOpen' && item.el && item.el[0]) {
                  clickedElement = item.el[0];
                }

                if (clickedElement) {
                  that.hideOriginalButton(clickedElement);
                  that.instantiatePlayer();
                  that.appendPlayerToPopup();       
                  isDone = true;
                }
              } catch (error) {
                // Silent error handling
              }
            }
          };

          this.ev.on('mfpOpen', magnificPopupSetup);
          this.ev.on('mfpChange', magnificPopupSetup);

          this.ev.on('mfpClose', () => {
            try {
              if (currentJwplayer.getCurrentPlayer()) {
                currentJwplayer.getCurrentPlayer().remove();
              }
            } catch (e) {
              // Silent error handling
            } finally {
              const originalElement = currentJwplayer.getCurrentPlayerElement();
              if (originalElement) {
                originalElement.style.display = '';
              }

              currentJwplayer.reset();
              isDone = false;
              clickedElement = null;
            }
          });

          return template;
        }
      }
    });

    const uglyJwplayerWrapperHack = () => {
      const videoObj = $('.js-video-popup');
      const jwChildWithPop = videoObj.find($('.js-video-popup'));
      if (jwChildWithPop.length > 0) {
        jwChildWithPop.removeClass('js-video-popup');
      }
    };    

    uglyJwplayerWrapperHack();
  }

  init() {
    $.each($(playerSelector), (index, player) => {
      if ($(player).parents('.image-carousel').length === 0) {
        const $player = $(player);        
        const isYouTube = $player.hasClass('js-video-youtube');
        let config;

        if (isYouTube) {
          const videoUrl = $player?.attr('href') || $player?.data('video-url');
          
          config = {
            items: { src: videoUrl },
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false,
            iframe: {
              patterns: {
                youtube: {
                  index: 'youtube.com/',
                  id: 'v=',
                  src: '//www.youtube.com/embed/%id%?autoplay=1'
                }
              }
            }
          };
        } else {
          config = {
            type: 'jwplayer',
            closeOnContentClick: false,
            closeBtnInside: true
          };
        }

        $player.on('keydown', (event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            $player.magnificPopup('open');
          }
        });

        $player.magnificPopup(config);
      }
    });
  }
}